module.exports = __webpack_public_path__ + "img/creme_brulee_sukker.cbffb8e4.jpg";